import { useMemo } from "react";

/**
 * Computes a live all-countries total for study plans while a single country's value is being edited.
 * @param {number} studyPlanType - The type of the study plan (1 for rates, 2 for duration)
 * @param {number} originalLowerBound - Current context lower bound value for this country's study plan
 * @param {number} editedLowerBound - Current locally edited lower bound value for this country's study plan
 * @param {number} originalUpperBound - Current context upper bound value for this country's study plan
 * @param {number} editedUpperBound - Current locally edited upper bound value for this country's study plan
 * @param {number} totalLowerBound - Total lower bound across all countries in context (siteActivationStats.totalLowerBound)
 * @param {number} totalUpperBound - Total upper bound across all countries in context (siteActivationStats.totalUpperBound)
 * @param {number} contextTotal - Total from all countries in context (siteActivationStats.sitesActivated)
 * @returns {number} Live total across all countries with the edited study plan values
 */
export const useActivatedSitesLiveTotal = (
    studyPlanType,
    originalLowerBound = 0,
    editedLowerBound = 0,
    originalUpperBound = 0,
    editedUpperBound = 0,
    totalLowerBound = 0,
    totalUpperBound = 0,
    contextTotal = 0
) => {
    return useMemo(() => {
        const originalLower = Number(originalLowerBound) || 0;
        const editedLower = Number(editedLowerBound) || 0;
        const originalUpper = Number(originalUpperBound) || 0;
        const editedUpper = Number(editedUpperBound) || 0;
        const totalUpper = Number(totalUpperBound) || 0;
        const totalLower = Number(totalLowerBound) || 0;
        const context = Number(contextTotal) || 0;
        if (studyPlanType === 1){

            // Replace original lower and upper bounds with edited values in the total
            return {
                lowerTotal: totalLower - originalLower + editedLower,
                upperTotal: totalUpper - originalUpper + editedUpper,
            };
        }
        else if (studyPlanType === 2){
            // Replace original value with edited value in the total
            return { activatedTotal: context - originalLower + editedLower };
        }
        return null;
        
    }, [studyPlanType, originalLowerBound, editedLowerBound, originalUpperBound, editedUpperBound, totalLowerBound, totalUpperBound, contextTotal]);
};